var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('page-with-button',{attrs:{"title":"You're on the waitlist!","titleDescription":"We are not yet live in your area","textDescription":`We are working hard and will notify you the moment we're there.
      \nSee you soon,
    The CareSend Team`,"img":require('@/assets/logo.png'),"icon":"check"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }